import React from "react";

const About = () => {
  return (
    <div>
      <section
        className="page-title-section overlay"
        data-background="images/backgrounds/page-title.jpg"
      >
        <div className="container">
          <div className="row">
            <div className="col-6">
              <img
                className="img-fluid mb-4 rounded-circle"
                src="images/slpLogo.jpg"
                style={{ width: "250px", height: "250px" }}
                alt="About"
              />
            </div>
            <div className="col-6">
              <ul className="list-inline custom-breadcrumb mb-2">
                <li className="list-inline-item text-white h3 font-secondary">
                  About Us
                </li>
              </ul>
              <p className="text-lighten mb-0">
                The speech clinic offers a range of services to help adults with speech and language disorders such as dysphagia, aphasia, stammeringand motor speech disorders.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <img
                className="img-fluid w-100 mb-4"
                src="images/file_0000000048b47208966317ba5f86e455.png"
                alt="About"
              />
              <h2 className="section-title">ABOUT OUR JOURNEY</h2>
              {/* <p> */}
              I’m Jamshaid Haider Malik, a Speech-Language Pathologist (MS-SLP) with formal academic training and clinical experience focused on adult and neurological speech therapy.
I hold a BS in Speech-Language Pathology (Gold Medalist) and a Master’s degree in Speech-Language Pathology/Therapy, with postgraduate focus on speech and language sciences, dysphagia management, and advanced clinical practice.
My clinical experience includes work in hospital, outpatient, and rehabilitation settings, providing assessment and therapy for adults with:
<ul>
  <li>Post-stroke speech and language difficulties</li>
  <li>Motor speech disorders</li>
  <li>Voice disorders
  </li>Aphasia
  <li>Swallowing (dysphagia) issues</li>
</ul>
I also serve in academic and clinical supervisory roles, ensuring my practice remains ethical, evidence-based, and outcome-focused.
                {/* </p> */}
                
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
